import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
let refreshing = null;
api.interceptors.response.use((response) => response, async (error) => {
  const config = error.config;
  if (error.response?.status === 401 && config && !config._retried &&
      (!config.url.includes("/auth/") || config.url === "/auth/me")) {
    config._retried = true;
    try {
      if (!refreshing) refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch { /* The original unauthorized response is shown to the caller. */ }
  }
  return Promise.reject(error);
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore inatteso";
}

export const STATUS_LABEL = { proposal: "Proposta", pending: "In attesa", approved: "Approvato", rejected: "Rifiutato" };

export const MONTHS = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export function kindLabel(pharmacy, key) {
  return pharmacy?.absence_types?.find((t) => t.key === key)?.label || key;
}

export function fmtHours(minutes) {
  const h = Math.floor((minutes || 0) / 60);
  const m = (minutes || 0) % 60;
  return `${h}h ${String(m).padStart(2, "0")}m`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });
}

export function timeInput(iso) {
  if (!iso) return "";
  // Return HH:MM as displayed in Europe/Rome (for time input fields)
  const parts = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/Rome",
  }).formatToParts(new Date(iso));
  const h = parts.find((p) => p.type === "hour")?.value || "00";
  const m = parts.find((p) => p.type === "minute")?.value || "00";
  return `${h}:${m}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}
